<template>
    <div class="holder">
        <v-datepicker ref="picker" :label="label" :name="name" :value="date" @input="inputHandler"></v-datepicker>
        <div class="date-controls" v-if="this.date">
            <span id="dateFilterPrevBtn" @click="prev"><i class="fa fa-angle-left"></i></span>
            <span id="dateFilterNextBtn" @click="next"><i class="fa fa-angle-right"></i></span>
        </div>
    </div>

</template>

<script>
    import field from '../mixins/field';
    import VDatepicker from './VDatepicker';
    import 'moment';

    export default {
      mixins: [field],
      components: {
        VDatepicker
      },
      data() {
        return {
          date: this.value,
        }
      },
      methods: {
        next() {
          if (this.date) {
            let datetime = this.date.split(' ');
            let date = datetime[0].split('-');
            let prevDate = new Date(date[2], parseInt(date[1]) - 1, date[0]).getTime();
            this.date = moment(prevDate).add(1, 'd').format('DD-MM-YYYY');
            this.$emit('next', this.date);
          }
        },
        prev() {
          if (this.date) {
            let datetime = this.date.split(' ');
            let date = datetime[0].split('-');
            let prevDate = new Date(date[2], parseInt(date[1]) - 1, date[0]).getTime();
            this.date = moment(prevDate).subtract(1, 'd').format('DD-MM-YYYY');
            this.$emit('prev', this.date);
          }
        },
        inputHandler(value) {
          this.date = value;
          this.$emit('phrase', value);
        }
      },
      watch: {
        value(newValue) {
          this.date = newValue;
        }
      }
    }
</script>
<style lang="scss">
    .holder {
        position: relative;
    }
    .date-controls {
        position: absolute;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
        z-index: 99;
        font-size: 16px;
    }
    .date-controls span {
        padding:10px;
        cursor: pointer;
    }
</style>